import { Application } from 'pixi.js'
import helpers from '../helpers'
import Grid from './Grid'
import Room from './Room'
import Item from './Item'
import store from '../store'

const app = new Application({
  width: 0,
  height: 0,
  transparent: false,
  antialias: true,
  preserveDrawingBuffer: true,
  resolution: window.devicePixelRatio,
  forceCanvas: helpers.methods.forceCanvas(),
  backgroundColor: 0xEBE2D1,
  autoResize: true,
})

const grid = new Grid({
  // cols: 20,
  // rows: 10,
  // cellSize: 40,
  // zoom: 0.5,
  // division: 5,
  // padding: 1,
})

app.stage.addChild(grid)

export { app, grid }


// WEBPACK FOOTER //
// ./assets/js/display/index.js